import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OrgSettingsComponent} from './org-settings.component';
import {OrgDetailsModalModule} from "../org-details-modal/org-details-modal.module";
import {OrgNameModalModule} from "../org-name-modal/org-name-modal.module";
import {DomainsModalModule} from "../domains-modal/domains-modal.module";
import {BrandColorsModalModule} from "../brand-colors-modal/brand-colors-modal.module";
import {BrandNameModalModule} from "../brand-name-modal/brand-name-modal.module";
import {EmailSmsLangModalModule} from "../email-sms-lang-modal/email-sms-lang-modal.module";
import {ParticipantLangModalModule} from "../participant-lang-modal/participant-lang-modal.module";
import {QuestionnaireLimitModalModule} from "../questionnaire-limit-modal/questionnaire-limit-modal.module";
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {ModalModule} from "ngx-bootstrap/modal";
import {AlertBannerModule} from "../../lib/alert-banner";
import {OrgLogoModalModule} from "../org-logo-modal/org-logo-modal.module";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import { OrgReferenceModule } from '../org-reference-settings/org-reference-settings.module';
import { LoaderModule } from '../loader/loader.module';

@NgModule({
  declarations: [OrgSettingsComponent],
  imports: [
    AlertBannerModule.forRoot(),
    AlertMessageModule,
    BrandColorsModalModule,
    OrgReferenceModule,
    BrandNameModalModule,
    CommonModule,
    DomainsModalModule,
    EmailSmsLangModalModule,
    ModalModule,
    OrgDetailsModalModule,
    OrgLogoModalModule,
    OrgNameModalModule,
    ParticipantLangModalModule,
    QuestionnaireLimitModalModule,
    TooltipModule.forRoot(),
    LoaderModule
  ],
  exports: [OrgSettingsComponent]
})
export class OrgSettingsModule {
}
